import NextImage from "@components/NextImage";
import React, {memo} from "react";

import {PartnerLogoType} from "../../../constants/LocationConstants";

type Props = {
  logo?: PartnerLogoType;
};
const PartnerLogo: React.FC<Props> = memo(({logo}) => {
  if (!logo) return null;
  return (
    logo.html || (
      <NextImage
        className="db"
        // @ts-expect-error TS2322: Type 'string | undefined' is not assignable to type 'string | StaticImport'.
        src={logo.src}
        extension={logo.ext}
        width={logo.width}
        height={logo.height}
        alt=""
      />
    )
  );
});

PartnerLogo.displayName = "PartnerLogo";

export default PartnerLogo;
